module.exports = __webpack_public_path__ + "1.5.0-unryo/img/offline-analytic-4.7732c621.svg";